import { useMsal } from "@azure/msal-react";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Typography } from "@mui/material";

import microsoft_icon from "../../images/login/microsoft_icon.png";

import { AuthContext } from "../../context/authContext";
import { onMsLogin } from "./onMsLogin";

export default function MSLoginButton() {
  const navigate = useNavigate();

  const { instance, inProgress, accounts } = useMsal();
  const { msLogin, setMsToken } = useContext(AuthContext);

  const handleLogin = () => {
    onMsLogin({
      instance,
      navigate,
      inProgress,
      accounts,
      msLogin,
      setMsToken,
    });
  };

  return (
    <Button
      type="submit"
      fullWidth
      variant="outlined"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "white",
      }}
      onClick={handleLogin}
    >
      <img
        style={{ height: "30px", width: "30px" }}
        src={microsoft_icon}
        alt="ms-icon"
      />
      <Typography variant="body1" style={{ marginLeft: "10px" }}>
        Sign In With Microsoft
      </Typography>
    </Button>
  );
}
